import { TranslationKeys } from '~/common/types';
import { IRedistributionBusinessRulesForm } from '~/connect/types';

export type RedistributionBusinessRuleNode = {
  field: keyof IRedistributionBusinessRulesForm;
  labelKey: keyof TranslationKeys;
  descriptionKey: keyof TranslationKeys;
  children?: Array<RedistributionBusinessRuleNode>;
  /** Turning one child on turns the others off — the API rejects any other combination. */
  exclusiveChildren?: boolean;
  /** Asks the user before switching the rule off; enabling it back stays silent. */
  disableConfirmation?: {
    titleKey: keyof TranslationKeys;
    messageKey: keyof TranslationKeys;
  };
};
export const REDISTRIBUTION_BUSINESS_RULES: Array<RedistributionBusinessRuleNode> =
  [
    {
      field: 'autoValidationEnabled',
      labelKey: 'app.redistribution.business_rules.auto_validation',
      descriptionKey:
        'app.redistribution.business_rules.auto_validation_description',
      children: [
        {
          field: 'internalOrderValidation',
          labelKey:
            'app.redistribution.business_rules.internal_order_validation',
          descriptionKey:
            'app.redistribution.business_rules.internal_order_validation_description',
        },
        {
          field: 'externalOrderValidation',
          labelKey:
            'app.redistribution.business_rules.external_order_validation',
          descriptionKey:
            'app.redistribution.business_rules.external_order_validation_description',
        },
      ],
    },
    {
      field: 'directStoreDelivery',
      labelKey: 'app.redistribution.business_rules.direct_store_delivery',
      descriptionKey:
        'app.redistribution.business_rules.direct_store_delivery_description',
      children: [
        {
          field: 'internalDirectStoreDelivery',
          labelKey:
            'app.redistribution.business_rules.internal_direct_store_delivery',
          descriptionKey:
            'app.redistribution.business_rules.internal_direct_store_delivery_description',
        },
        {
          field: 'externalDirectStoreDelivery',
          labelKey:
            'app.redistribution.business_rules.external_direct_store_delivery',
          descriptionKey:
            'app.redistribution.business_rules.external_direct_store_delivery_description',
        },
      ],
    },
    // {
    //   field: 'sendOrderToDms',
    //   labelKey: 'app.redistribution.business_rules.send_order_to_dms',
    //   descriptionKey:
    //     'app.redistribution.business_rules.send_order_to_dms_description',
    //   exclusiveChildren: true,
    //   disableConfirmation: {
    //     titleKey:
    //       'app.redistribution.business_rules.send_order_to_dms_disable_title',
    //     messageKey:
    //       'app.redistribution.business_rules.send_order_to_dms_disable_message',
    //   },
    //   children: [
    //     {
    //       field: 'dmsAutomaticSending',
    //       labelKey: 'app.redistribution.business_rules.dms_automatic_sending',
    //       descriptionKey:
    //         'app.redistribution.business_rules.dms_automatic_sending_description',
    //     },
    //     {
    //       field: 'dmsManualSending',
    //       labelKey: 'app.redistribution.business_rules.dms_manual_sending',
    //       descriptionKey:
    //         'app.redistribution.business_rules.dms_manual_sending_description',
    //     },
    //   ],
    // },
  ];
